export class AuthenticationConstants {
  public static readonly IS_AUTHENTICATION_MODULE_AVAILABLE = '__waflpdfipkyqeuooewydiohgxirjeixroqqkklhvezyoavvecoswvqlqpnjmisxe';
}
